import Colors from "assets/Colors";
import BarChartStacked from "components/common/BarChartStacked";
import Loading from "components/common/loading";
import { useTranslation } from "react-i18next";
import s from "./styles";
import AlertIcon from "components/icons/AlertIcon";

function PaymentType({ color, text }) {
  return (
    <s.ContainerColorPaymentType>
      <s.RoundColor style={{ background: color }} />
      <s.PaymentTypeText>{text}</s.PaymentTypeText>
    </s.ContainerColorPaymentType>
  );
}

function BarChart({
  cardData,
  cashData,
  otherData,
  title,
  loading,
  secondGraph,
  noData,
}) {
  const { t } = useTranslation();

  return (
    <s.Container ref={secondGraph}>
      <s.HeaderContainer>
        <s.Title>{title}</s.Title>
        <s.TypesContainer>
          <PaymentType
            color={`${Colors.primary_web_color2}`}
            text={t("general.card")}
          />
          <PaymentType
            color={`${Colors.primary_web_color1}`}
            text={t("general.cash")}
          />
          <PaymentType
            color={`${Colors.background_dividers}`}
            text={t("general.others")}
          />
        </s.TypesContainer>
      </s.HeaderContainer>

      {loading ? (
        <Loading height="260px" size="middle" />
      ) : noData ? (
        <s.NoItemsContainer>
          <s.NoItemsMessageCenter>
            <AlertIcon style={{ display: "block", marginBottom: "7px" }} />
            {t("general.noData")}
          </s.NoItemsMessageCenter>
        </s.NoItemsContainer>
      ) : (
        <s.ChartContainer>
          <BarChartStacked
            data={{
              columns: cardData.map((v) => v.label),
              types: [
                {
                  label: t("general.card"),
                  data: cardData.map((v) => v.number),
                  backgroundColor: `${Colors.primary_web_color2}`,
                },
                {
                  label: t("general.cash"),
                  data: cashData.map((v) => v.number),
                  backgroundColor: `${Colors.primary_web_color1}`,
                },
                {
                  label: t("general.others"),
                  data: otherData.map((v) => v.number),
                  backgroundColor: `${Colors.background_dividers}`,
                },
              ],
            }}
          />
        </s.ChartContainer>
      )}
    </s.Container>
  );
}

export default BarChart;
